import React from 'react';
import { currentFy, recentFys, PERIOD_OPTIONS } from '../../../utils/indianFy';

/**
 * Shared period control for Compliance hub reports.
 */
export default function CompliancePeriodBar({
  period,
  onPeriodChange,
  fy,
  onFyChange,
  showFy = true,
  fyOptions,
  className = '',
}) {
  const fys = fyOptions || recentFys(3);

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <div className="inline-flex rounded-lg border border-gray-200 overflow-hidden">
        {PERIOD_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            onClick={() => onPeriodChange(opt.value)}
            className={`px-3 py-1.5 text-xs font-semibold ${
              period === opt.value
                ? 'bg-[#1B375B] text-white'
                : 'bg-white text-gray-600 hover:bg-gray-50'
            }`}
            data-testid={`period-${opt.value}`}
          >
            {opt.label}
          </button>
        ))}
      </div>
      {showFy && period === 'fy' && (
        <select
          value={fy}
          onChange={(e) => onFyChange(e.target.value)}
          className="px-3 py-1.5 border border-gray-200 rounded-lg text-sm"
          data-testid="compliance-fy-select"
        >
          {fys.map((f) => (
            <option key={f} value={f}>{f}</option>
          ))}
        </select>
      )}
    </div>
  );
}

export { currentFy, recentFys };
